interface RestService {
  get: (url: string) => Promise<string>
  post: (url: string, data: any) => Promise<any>
}

// Types for PayPal order response
interface PayPalOrderResponse {
  id: string
  status: string
  create_time: string
  update_time: string
  amount: {
    currency_code: string
    value: string
  }
  payment_source: {
    card: {
      last_digits: string
      brand: string
      type: string
    }
  }
  links: Array<{
    href: string
    rel: string
    method: string
  }>
  purchase_units: Array<{
    reference_id: string
    amount: {
      currency_code: string
      value: string
    }
    payments: {
      captures: Array<{
        id: string
        status: string
        amount: {
          currency_code: string
          value: string
        }
        create_time: string
        update_time: string
      }>
    }
  }>
  payer: {
    email_address: string
    payer_id: string
  }
}

// Types for PayPal transaction
interface PayPalTransaction {
  id: string
  paypalPaymentId: string
  orderId: string
  amount: number
  currency: string
  status: string
  paymentMethodId: string
  payerId: string
  createdAt: string
  updatedAt: string
  refundedAmount?: number
  refundStatus?: string
  refundedAt?: string
}

interface PayPalFinalizeVaultResponse {
  capture: PayPalTransaction
  refund: PayPalTransaction
}

export const GetPaypalClientToken =
  ({
    RestService,
    HandleError,
  }: {
    RestService: RestService
    HandleError: (params: { error: any }) => void
  }) =>
  async (): Promise<string | null> => {
    try {
      const clientToken = await RestService.get('/payments/paypal-client-token')

      return clientToken
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

export const CreatePaypalVaultOrder =
  ({
    RestService,
    HandleError,
  }: {
    RestService: RestService
    HandleError: (params: { error: any }) => void
  }) =>
  async (params: {
    currency: string
    cardholderName: string
    billingAddress?: any
  }): Promise<PayPalOrderResponse | null> => {
    try {
      const response = await RestService.post(
        `/payments/paypal-vault-card-order`,
        {
          cardholderName: params.cardholderName,
          currency: params.currency,
          billingAddress: params.billingAddress,
        },
      )

      return response
    } catch (error) {
      HandleError({ error })

      return null
    }
  }

interface PaypalErrorResponse {
  errorMessage: string
}

export const FinalizePaypalVaultOrder =
  ({
    RestService,
    pResponseErrorMessage,
  }: {
    RestService: RestService
    pResponseErrorMessage: (error: any) => PaypalErrorResponse
  }) =>
  async (params: {
    orderId: string
  }): Promise<PayPalFinalizeVaultResponse | string> => {
    try {
      const response = await RestService.post(
        `/payments/paypal-vault-card-order/${params.orderId}/finalize`,
        null,
      )

      return response
    } catch (error) {
      return pResponseErrorMessage(error).errorMessage
    }
  }
